import certificatesI18n from '../../../../locales/en/pages/lostCertificate/certificates.json';
import companyAndAccountI18n from '../../../../locales/en/pages/lostCertificate/companyAndAccount.json';
import reportedCertificatesI18n from '../../../../locales/en/pages/lostCertificate/reportedCertificates.json';
import addCertificateI18n from '../../../../locales/en/pages/lostCertificate/addCertificate.json';
import reviewI18n from '../../../../locales/en/pages/lostCertificate/review.json';
import summary from '../../../../locales/en/pages/lostCertificate/summary.json';

export enum CertificatesResourceKeys {
  certificates = 'pages/lostCertificate/certificates',
  companyAndAccount = 'pages/lostCertificate/companyAndAccount',
  reportedCertificates = 'pages/lostCertificate/reportedCertificates',
  addCertificate = 'pages/lostCertificate/addCertificate',
  review = 'pages/lostCertificate/review',
  summary = 'pages/lostCertificate/summary',
}

export type CertificatesResources = {
  [CertificatesResourceKeys.certificates]: typeof certificatesI18n;
  [CertificatesResourceKeys.reportedCertificates]: typeof reportedCertificatesI18n;
  [CertificatesResourceKeys.companyAndAccount]: typeof companyAndAccountI18n;
  [CertificatesResourceKeys.addCertificate]: typeof addCertificateI18n;
  [CertificatesResourceKeys.review]: typeof reviewI18n;
  [CertificatesResourceKeys.summary]: typeof summary;
};
